import { render, staticRenderFns } from "./ContractualItemHandlePerson.vue?vue&type=template&id=48b42236"
import script from "./ContractualItemHandlePerson.vue?vue&type=script&lang=js"
export * from "./ContractualItemHandlePerson.vue?vue&type=script&lang=js"
import style0 from "./ContractualItemHandlePerson.vue?vue&type=style&index=0&id=48b42236&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports